import { Card } from "antd";

export default function PageNews() {
	return <Card>PAGENEWS IS UNDER CONSTRUCTION</Card>;
}
